/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { CompanyFragmentFragmentDoc } from './companyFragment.generated';
import { UserFragmentFragmentDoc } from './userFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Brand_Enum =
  /** G20 */
  | 'G20'
  /** Auchan Hyper */
  | 'auchan_hyper'
  /** Auchan MyAuchan */
  | 'auchan_myauchan'
  /** Auchan Super */
  | 'auchan_super'
  /** Biocoop */
  | 'biocoop'
  /** Carrefour City */
  | 'carrefour_city'
  /** Carrefour Contact */
  | 'carrefour_contact'
  /** Carrefour Express */
  | 'carrefour_express'
  /** Carrefour Hyper */
  | 'carrefour_hyper'
  /** Carrefour Market */
  | 'carrefour_market'
  /** Coccimarket */
  | 'coccimarket'
  /** Coccimarket City */
  | 'coccimarket_city'
  /** Coccimarket Easy */
  | 'coccimarket_easy'
  /** Cora */
  | 'cora'
  /** Diago */
  | 'diago'
  /** E.Leclerc */
  | 'e_leclerc'
  /** E.Leclerc Express */
  | 'e_leclerc_express'
  /** Franprix */
  | 'franprix'
  /** Hyper U */
  | 'hyper_u'
  /** Intermarché Contact */
  | 'intermarche_contact'
  /** Intermarché Express */
  | 'intermarche_express'
  /** Intermarché Hyper */
  | 'intermarche_hyper'
  /** Intermarché Super */
  | 'intermarche_super'
  /** Monop’ */
  | 'monop'
  /** Monoprix */
  | 'monoprix'
  /** Netto */
  | 'netto'
  /** Sitis Market */
  | 'sitis_market'
  /** Spar */
  | 'spar'
  /** Super U */
  | 'super_u'
  /** U Express */
  | 'u_express'
  /** Utile */
  | 'utile';

export type Business_Profile_Enum =
  | 'BUYER'
  | 'SUPPLIER';

export type Contract_Status_Enum =
  | 'SIGNED'
  | 'UNSIGNED';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type ContractPropositionInfoQueryVariables = Exact<{
  buyingCompanyId: string;
  supplyingCompanyId: string;
}>;


export type ContractPropositionInfoQuery = { contract: Array<{ id: string, status: Types.Contract_Status_Enum, proposer_business_profile: Types.Business_Profile_Enum | null, proposer_user_id: string | null, minimum_order_value: number | null, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, discount: number, custom_price_list_id: string | null, sub_catalog_id: string | null, supplier_commission_rate: number | null, supplyingCompanyId: string, buyingCompanyId: string, custom_price_list: { name: string } | null, sub_catalog: { name: string } | null, supplying_company: { id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, tradeName: string, brand: Types.Brand_Enum | null, delivery_zones: Array<{ minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, administrative_areas: Array<{ area: string }> }>, role_assignments: Array<{ user: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } }>, photos: Array<{ photo: { path: string, domain: string | null } }> }, buying_company: { tradeName: string, id: string, business_profile: Types.Business_Profile_Enum, description: string | null, contactEmail: string, contactPhoneNumber: string, brand: Types.Brand_Enum | null, addresses: Array<{ administrativeAreaLevel2: string | null }>, role_assignments: Array<{ user: { id: string, first_name: string, last_name: string, auth_provider_avatar_url: string | null, default_avatar: { domain: string | null, path: string } | null } }>, photos: Array<{ photo: { path: string, domain: string | null } }> } }> };


export const ContractPropositionInfoDocument = /*#__PURE__*/ gql`
    query ContractPropositionInfo($buyingCompanyId: uuid!, $supplyingCompanyId: uuid!) {
  contract(
    where: {buyingCompanyId: {_eq: $buyingCompanyId}, supplyingCompanyId: {_eq: $supplyingCompanyId}}
  ) {
    id
    status
    proposer_business_profile
    proposer_user_id
    minimum_order_value
    minimum_order_value_type
    discount
    custom_price_list_id
    custom_price_list {
      name
    }
    sub_catalog_id
    sub_catalog {
      name
    }
    supplier_commission_rate
    supplyingCompanyId
    buyingCompanyId
    supplying_company {
      ...companyFragment
      delivery_zones {
        minimum_order_value
        minimum_order_value_type
        administrative_areas {
          area
        }
      }
      role_assignments(where: {role_name: {_neq: COMPANY_ADMIN}}) {
        user {
          ...userFragment
        }
      }
    }
    buying_company {
      ...companyFragment
      tradeName
      addresses {
        administrativeAreaLevel2
      }
      role_assignments(where: {role_name: {_neq: COMPANY_ADMIN}}) {
        user {
          ...userFragment
        }
      }
    }
  }
}
    ${CompanyFragmentFragmentDoc}
${UserFragmentFragmentDoc}`;

/**
 * __useContractPropositionInfoQuery__
 *
 * To run a query within a React component, call `useContractPropositionInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractPropositionInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractPropositionInfoQuery({
 *   variables: {
 *      buyingCompanyId: // value for 'buyingCompanyId'
 *      supplyingCompanyId: // value for 'supplyingCompanyId'
 *   },
 * });
 */
export function useContractPropositionInfoQuery(baseOptions: Apollo.QueryHookOptions<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables> & ({ variables: ContractPropositionInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>(ContractPropositionInfoDocument, options);
      }
export function useContractPropositionInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>(ContractPropositionInfoDocument, options);
        }
// @ts-ignore
export function useContractPropositionInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>;
export function useContractPropositionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>): Apollo.UseSuspenseQueryResult<ContractPropositionInfoQuery | undefined, ContractPropositionInfoQueryVariables>;
export function useContractPropositionInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>(ContractPropositionInfoDocument, options);
        }
export type ContractPropositionInfoQueryHookResult = ReturnType<typeof useContractPropositionInfoQuery>;
export type ContractPropositionInfoLazyQueryHookResult = ReturnType<typeof useContractPropositionInfoLazyQuery>;
export type ContractPropositionInfoSuspenseQueryHookResult = ReturnType<typeof useContractPropositionInfoSuspenseQuery>;
export type ContractPropositionInfoQueryResult = Apollo.QueryResult<ContractPropositionInfoQuery, ContractPropositionInfoQueryVariables>;